import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { maskTelefone, unmaskTelefone } from "@/lib/utils";
import { UseFormReturn } from "react-hook-form";
import { CriarPacienteFormData } from "../schemas/paciente.schema";

interface AbaInformacoesAdicionaisProps {
  form: UseFormReturn<CriarPacienteFormData>;
  formData: CriarPacienteFormData;
}

export const AbaInformacoesAdicionais = ({ form, formData }: AbaInformacoesAdicionaisProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Informações Adicionais</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="cartao_sus">Cartão SUS</Label>
            <Input 
              id="cartao_sus" 
              value={formData.cartao_sus || ""} 
              onChange={(e) => form.setValue("cartao_sus", e.target.value)} 
              placeholder="Número do cartão SUS"
            />
          </div>
          <FormField
            control={form.control}
            name="matricula_convenio"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Matrícula do Convênio</FormLabel>
                <FormControl>
                  <Input 
                    {...field}
                    value={field.value || ""} 
                    onChange={(e) => {
                      const value = e.target.value;
                      // Limita a 20 caracteres
                      if (value.length <= 20) {
                        field.onChange(value);
                      }
                    }}
                    placeholder="Matrícula do convênio"
                    maxLength={20}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="observacoes">Observações</Label>
          <Textarea 
            id="observacoes" 
            value={formData.observacoes || ""} 
            onChange={(e) => form.setValue("observacoes", e.target.value)} 
            placeholder="Observações sobre o paciente"
            rows={3}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="acompanhante">Acompanhante</Label>
            <Input 
              id="acompanhante" 
              value={formData.acompanhante || ""} 
              onChange={(e) => form.setValue("acompanhante", e.target.value)} 
              placeholder="Nome do acompanhante"
            />
          </div>
          <FormField
            control={form.control}
            name="fone_acompanhante"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Telefone do Acompanhante</FormLabel>
                <FormControl>
                  <Input 
                    value={maskTelefone(field.value || "")} 
                    onChange={(e) => field.onChange(unmaskTelefone(e.target.value))} 
                    placeholder="(62) 99999-9999"
                    maxLength={15}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="endereco_acompanhante">Endereço do Acompanhante</Label>
          <Input 
            id="endereco_acompanhante" 
            value={formData.endereco_acompanhante || ""} 
            onChange={(e) => form.setValue("endereco_acompanhante", e.target.value)} 
            placeholder="Endereço do acompanhante"
          />
        </div>
      </CardContent>
    </Card>
  );
};
